import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import React from 'react';
import moment from 'moment';
import { FBHeader } from 'components/SocialPreviews';
import { Video } from 'components';
import * as styles from './PostPlatformPreview.scss';

function FacebookPreview(props) {
  var account = props.account,
      groupPost = props.groupPost,
      images = props.images,
      link = props.link,
      linkCaption = props.linkCaption,
      linkTitle = props.linkTitle,
      message = props.message,
      postDate = props.postDate,
      postType = props.postType,
      videos = props.videos;
  var m = message && "".concat(message).replace(/\s+/g, '') ? /*#__PURE__*/React.createElement("p", {
    className: styles.fb_post_p
  }, message) : /*#__PURE__*/React.createElement("p", {
    className: styles.fb_post_p
  }, /*#__PURE__*/React.createElement("i", null, "Type a message to see the preview here."));
  var accountInfo = {
    profileImage: 'https://s3.amazonaws.com/likeabucket/user_upload/232/-M3b2fGE6.jpeg',
    profileName: 'Username'
  };

  if (account) {
    accountInfo.profileImage = account.avatarImageUrl;
    accountInfo.profileName = account.username;
  }

  if (!link) {
    var imgList = images;
    var videoList = [];

    if (videos && videos.length > 0) {
      imgList = [];
      videoList = videos;
    }

    if (postType !== 'linkPost' && postType !== 'imagePost') {
      imgList = [];
    }

    var imgTags = imgList.map(function (url, idx) {
      var styleObj = {
        backgroundImage: "url(".concat(url, ")"),
        backgroundPosition: 'center center',
        paddingBottom: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: imgList.length > 1 ? 'cover' : 'contain',
        display: 'inline-block',
        width: '100%'
      };
      var classColSize = 12;

      if (imgList.length === 4) {
        classColSize = 6;
        styleObj.paddingBottom = '50%';
      } else if (imgList.length === 2) {
        classColSize = 12;
        styleObj.paddingBottom = '50%';
      } else if (imgList.length === 3) {
        if (idx === 1 || idx === 2) {
          classColSize = 6;
        } else {
          classColSize = 12;
        }

        styleObj.paddingBottom = '50%';
      }

      if (imgList.length > 1) {
        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: "col-xs-".concat(classColSize),
          style: styleObj
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "col-xs-".concat(classColSize)
      }, /*#__PURE__*/React.createElement("img", {
        src: url,
        style: {
          maxWidth: '100%'
        }
      }));
    });
    var videoTags = videoList.map(function (url, idx) {
      return url.indexOf('blarplesnurf') === -1 || url.indexOf('blarplesnurf-staging') === -1 ? /*#__PURE__*/React.createElement(Video, {
        src: url,
        key: idx,
        style: {
          width: '100%',
          height: '100%'
        },
        autoPlay: true,
        loop: true,
        controls: true,
        muted: true
      }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Your video is being processed. One moment..."), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-spinner fa-spin"
      }));
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles.facebook_preview
    }, /*#__PURE__*/React.createElement(FBHeader, {
      account: account,
      groupPost: groupPost,
      dateText: moment.apply(void 0, _toConsumableArray([postDate].filter(function (n) {
        return n;
      }))).format('M/D/YYYY, h:mm a')
    }), /*#__PURE__*/React.createElement("div", {
      className: styles.fb_post,
      id: "test-fb-message"
    }, m, /*#__PURE__*/React.createElement("div", {
      className: styles.img_container
    }, imgTags, videoTags))), /*#__PURE__*/React.createElement("div", {
      className: styles.fb_actions
    }, /*#__PURE__*/React.createElement("img", {
      style: {
        width: '100%'
      },
      src: "https://s3.amazonaws.com/likeabucket/user_upload/232/8HeADTcW.jpeg"
    })));
  }

  var imgContainer = images && images.length > 0 ? /*#__PURE__*/React.createElement("div", {
    style: {
      backgroundImage: "url(".concat(images[0], ")"),
      paddingBottom: '50%',
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      borderBottom: '1px solid #DBDBDB'
    }
  }) : null;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.facebook_preview
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.fb_profile
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.profile_img,
    src: accountInfo.profileImage
  }), /*#__PURE__*/React.createElement("h3", {
    className: styles.name
  }, accountInfo.profileName), /*#__PURE__*/React.createElement("small", {
    className: styles.fb_profile_small
  }, postDate ? postDate.format('MM/DD/YYYY, h:mm a') : '')), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: styles.fb_post,
    id: "test-fb-message"
  }, m, /*#__PURE__*/React.createElement("div", {
    className: styles.img_container
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      border: '1px solid #DBDBDB',
      textAlign: 'left'
    }
  }, imgContainer, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '5px 10px'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("small", {
    style: {
      color: '#8b8b8b',
      fontFamily: 'sans-serif',
      fontSize: 12
    }
  }, linkCaption ? linkCaption.toUpperCase() : '')), /*#__PURE__*/React.createElement("h4", {
    style: {
      color: '#333333',
      fontFamily: 'sans-serif',
      fontSize: 18,
      marginTop: 5,
      marginBottom: 5
    }
  }, linkTitle)))))), /*#__PURE__*/React.createElement("div", {
    className: styles.fb_actions
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: '100%'
    },
    src: "https://s3.amazonaws.com/likeabucket/user_upload/232/8HeADTcW.jpeg"
  })));
}

export default FacebookPreview;